import { HfInference } from "@huggingface/inference";
import { HF_TOKEN } from "utils/config";

const inference = new HfInference(HF_TOKEN);

export async function formatText(text: string) {
  if (!text.trim()) {
    return {
      formattedText: "",
      error: null,
    };
  }
  let formattedText = "";
  const content = `Just Punctuate the text block and do nothing else, do not display anything in the textarea if the text string is undefined or unrecognizable, do not also insert any explanation and don't wrap the final text in quote:  ${text}`;

  try {
    for await (const chunk of inference.chatCompletionStream({
      model: "mistralai/Mistral-7B-Instruct-v0.3",
      messages: [
        {
          role: "user",
          content,
        },
      ],
      max_tokens: 500,
      temperature: 0,
    })) {
      if (chunk.choices && chunk.choices.length > 0) {
        formattedText += chunk.choices[0].delta.content;
      }
    }

    return {
      formattedText: formattedText.trim(),
      error: null,
    };
  } catch (error) {
    console.log(error);
    return {
      formattedText: "",
      error: "Text formatting failed",
    };
  }
}
